import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { NotificationService, NotificationType } from '../../services/notification.service'

@Component({
  selector: 'bmcore-notification',
  templateUrl: './bmcore-notification.component.html',
  styleUrls: ['./bmcore-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNotificationComponent implements OnInit {
  isShowNotification = false
  notifyArray: NotificationType[] = []

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notificationService.$notificationSubj.subscribe((notification: NotificationType) => {
      this.isShowNotification = true
      this.notifyArray.unshift(notification)
      this.hideNotificationAfterTime(notification.id)
    })
  }

  hideNotificationAfterTime(notifyId: number) {
    setTimeout(() => {
      this.closeNotification(notifyId)
    }, 6000)
  }

  closeNotification(notifyId: number) {
    this.notifyArray = this.notifyArray.filter(n => {
      return n.id !== notifyId
    })
    if (this.notifyArray.length <= 0) {
      this.isShowNotification = false
    }
  }
}
